//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "help",
  data() {
    return {
      /** 侧栏菜单显示 */
      is_sidebar_help_menu_show: false,
    };
  },
  methods: {},
  watch: {
    $route() {
      this.is_sidebar_help_menu_show = false;
    },
  },
  created() {},
};
